import { HttpClient } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { VoyageCareIntgrationCompenent } from "./voyage-care.component";
import { CustomTranslateLoader } from "../../../../_services/custom.loader";



@NgModule({
  declarations: [
    VoyageCareIntgrationCompenent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  exports: [VoyageCareIntgrationCompenent],
})
export class DateVoyageCareIntegrationModule { }
